<div class="modal fade" id="kt_modal_add_saved_search" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-550px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">Save Search</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="savedSearchForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Search Name -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Search Name</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="name"
                placeholder="Enter a name for this search"
                [class.is-invalid]="name?.invalid && name?.touched"
              />
              <div *ngIf="name?.invalid && name?.touched" class="invalid-feedback">
                <div *ngIf="name?.errors?.['required']">Search name is required</div>
                <div *ngIf="name?.errors?.['minlength']">Search name must be at least 3 characters</div>
              </div>
            </div>

            <!-- Display selected filters summary -->
            <div class="col-md-12 mb-3" *ngIf="searchData">
              <label class="form-label">Selected Filters:</label>
              <div class="bg-light-primary p-3 rounded">
                <div *ngFor="let key of searchData | keyvalue" class="mb-1">
                  <span class="fw-bold text-gray-700">{{ key.key }}:</span>
                  <span class="text-gray-600 ms-2">{{ key.value }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer p-3">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading"
          >
            <span class="indicator-label" *ngIf="!isLoading">
              <i class="ki-duotone ki-save-2 fs-2">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
              Save Search
            </span>
            <span class="indicator-progress" *ngIf="isLoading">
              Please wait...
              <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
